/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IDataTableHeader } from '../BreakdownByMeter/BreakdownByMeterProps';

export interface ISavingsMeterWidgetProps {
  meterData: Array<ISavingsMeterProps>;
  columnHeaders: IDataTableHeader[];
  category?: string;
  onSorting?: (sortOrder: number) => void;
  toggleFeatureScopeOne?: boolean;
  type?: string;
  emissionMeasurementUnit: string;
  hideChange?: boolean;
}

export interface IEmissionByUtilityProps {
  utilityType: string;
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
  meters: Array<IMetersProps>;
}
export interface IMetersProps {
  meterId: string;
  meterNumber: string;
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
}
export interface ISavingsMeterProps {
  ConsumptionTypeName: string;
  ConsumptionHigh?: string | null;
  ConsumptionDeviation: string | null;
  TotalDeviation: number | null;
  unit?: string;
  totalDeviationUnit?: string;
  deviationPercentage?: number;
  deviationUnit?: string;
}

export enum CarbonUtilityType {
  ELECTRICITY = 'Electricity',
  ELECTRIC = 'Electric',
  GAS = 'Gas'
}

export enum CarbonUtilityTypeScope {
  GAS = 'Scope 1',
  ELECTRICITY = 'Scope 2',
  INVALID = 'Invalid'
}

export interface IMeterSavings {
  // meter: string;
  totalActualConsumption: number | null;
  previousPeriodConsumption: number | null;
  percentageConsumptionSaving: number | null; //totalConsumptionSavingsPercentage
  totalActualCost: number;
  previousPeriodCost: number;
  percentageCostSavings: number; //totalCostSavingsPercentage
  type: string;
  consumptionSavings: number | null;
  costSavings: number;
  unit?: string;
  costSavingsPercentage: number | null;
  consumptionSavingsPercentage: number | null;
  measurementUnit: string;
  changeUnit?: string;
  actualUnit?: string;
  baselineUnit?: string;
  fromUnit?: string;
  meterType?: string;
}

export interface IUtilityMeterSavings {
  meter: string;
  totalActualConsumption: number | null;
  previousPeriodConsumption: number | null;
  percentageConsumptionSaving: number | null; //totalConsumptionSavingsPercentage
  totalActualCost: number;
  previousPeriodCost: number;
  percentageCostSavings: number | null; //totalCostSavingsPercentage
  meterType: string;
  totalConsumptionSavings: number | null;
  totalCostSavings: number | null;
  actualUnit?: string;
  baselineUnit?: string;
  changeUnit?: string;
}

export interface IAllMeterSavings {
  totalActualConsumption: number;
  previousPeriodConsumption: number;
  percentageConsumptionSaving: number; //totalConsumptionSavingsPercentage
  totalActualCost: number;
  previousPeriodCost: number;
  percentageCostSavings: number; //totalCostSavingsPercentage
  type: string;
  consumptionSavings: number;
  costSavings: number;
  converSionUnit: string;
}

export interface IUtilityCostSavings {
  siteId: string;
  siteName: string;
  totalActualConsumption: number | null;
  previousPeriodConsumption: number | null;
  percentageConsumptionSaving: number | null;
  totalActualCost: number;
  previousPeriodCost: number;
  percentageCostSavings: number;
  utilityType: string;
  totalConsumptionSavings: number | null;
  totalCostSavings: number | null;
  actualUnit?: string;
  baselineUnit?: string;
  changeUnit?: string;
}
